const preSortedAttributes = ['PIM_ATT_SPEEDINDEX'];

export default preSortedAttributes;
